import { PropsWithChildren } from 'react';
import { Badge as _Badge } from '@chakra-ui/react';

export type BadgeProps = PropsWithChildren;

export const Badge = ({ children }: BadgeProps) => (
   <_Badge
      ml={2}
      fontSize="13px"
      fontWeight="400"
      px="8px"
      py="2px"
      backgroundColor="#D9D3CF"
      color="#17191C"
   >
      {children}
   </_Badge>
);
